<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}:{{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" :busy="isBusy" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(nominativo)="{ item }">
                        <span>{{ item.lastname }} {{ item.firstname }}</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-info" title="Associa Utente" @click="onAssociaUtente(row.item)" class="mr-1 no-text" v-if="row.item.firstname === null && row.item.lastname === null">
                                <b-icon icon="people-fill"></b-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Box" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Box" @click="onDelete(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <b-modal size="lg" ref="modalAssocia" id="modalAssociaUtente" title="Associa Utente" scrollable>
            <b-form @submit.prevent="onSubmitUsers">
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-form-input v-model="mdlFiltroUsers.username" type="search" placeholder="Username"></b-form-input>
                    </b-col>
                    <!-- 
                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                        <b-form-select v-model="mdlFiltroUsers.profilo" :options="profiliModalOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    </b-col> -->
                </b-row>
                <b-row>
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">Cerca</b-button>
                    </b-col>
                </b-row>
            </b-form>
            <div class="b-table-sticky-header">
                <b-table sticky-header :busy="isBusy" ref="table" selectable stacked="lg" striped hover :items="itemsUtenti" :fields="fieldsModal" sort-icon-left head-variant="light" class="sa-b-table" current-page="1" :per-page="perPageUsers" @row-selected="onRowSelected">
                    <template #table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Caricamento...</strong>
                        </div>
                    </template>
                    <template #cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                        </template>
                        <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                        </template>
                    </template>
                    <template #cell(firstname)="row">
                        <p>{{ row.item.lastname }} {{ row.item.firstname }}</p>
                    </template>
                </b-table>
            </div>

            <template #modal-footer="{ ok }">
                <b-button size="sm" variant="outline-danger" @click="ok()">
                    <b-icon icon="x"></b-icon>
                    Annulla
                </b-button>
                <b-button size="sm" variant="outline-success" @click="onAssocia()">
                    <b-icon icon="person-check-fill"></b-icon>
                    Associa
                </b-button>
            </template>
        </b-modal>
        <configurazione-agenda-box-edit-modal-component ref="cmpConfigurazioneAgendaBoxEditModal" @afterSave="onAfterSave"></configurazione-agenda-box-edit-modal-component>
    </div>
</template>
<script>
import axios from "axios";
import ConfigurazioneAgendaBoxEditModalComponent from "./ConfigurazioneAgendaBoxEditModalComponent.vue";
export default {
    components: { ConfigurazioneAgendaBoxEditModalComponent },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            filtroConfigurazioneAgendaBox: {},
            pathResource: "/agendebox",
            pathResourceAgendaBoxUtente: "/agendeboxutenti",
            pathResourceUtenti: "/users",
            pathResourceGruppiUtenti: "/gruppi",
            showModalLoading: false,
            show: true,
            perPage: 50,
            perPageUsers: 100000,
            currentPage: 1,
            currentPageUsers: 1,
            rows: 0,
            rowsUsers: 0,
            listKey: 0,
            isBusy: false,
            items: [],
            mdlFiltroUsers: {
                profilo: "",
                username: "",
            },
            jsonDataAgendaBox: {},
            filtroUsers: {},
            selected: [],
            itemsUtenti: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                { label: "Nome", key: "nome", sortable: true },
                { label: "Nominativo Medico", key: "nominativo", sortable: true },
                { label: "Note", key: "note", sortable: true },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            fieldsModal: [
                {
                    label: "",
                    key: "selected",
                    thStyle: "width: 2.5rem",
                    tdClass: "text-center",
                },
                {
                    label: "Username",
                    key: "username",
                    sortable: true,
                    thStyle: "width: 8rem",
                },
                {
                    label: "Nome",
                    key: "firstname",
                    sortable: true,
                    thStyle: "width: 8rem",
                },
                {
                    label: "Profilo",
                    key: "profilo",
                    sortable: true,
                    thStyle: "width: 8rem",
                },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            this.openShowModalLoading();
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroConfigurazioneAgendaBox"]) {
                me.filtroConfigurazioneAgendaBox = JSON.parse(sessionStorage["filtroConfigurazioneAgendaBox"]);
            }
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtroConfigurazioneAgendaBox.page = me.currentPage;
            me.filtroConfigurazioneAgendaBox.forPage = me.perPage;
            axios
                .get(link, { params: me.filtroConfigurazioneAgendaBox })
                .then((response) => {
                    me.rows = response.data.data.list.length;
                    me.items = response.data.data.list;
                    me.listKey++;
                    me.closeShowModalLoading();
                })
                .catch(() => {
                    me.closeShowModalLoading();
                });
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onEdit(item) {
            let me = this;
            me.$refs.cmpConfigurazioneAgendaBoxEditModal.edit(item.id);
        },
        nuovo() {
            let me = this;
            me.$refs.cmpConfigurazioneAgendaBoxEditModal.show();
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare il Box Agenda " + item.nome)
                .then((value) => {
                    if (value) {
                        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                        axios.delete(link + item.id).then(() => {
                            me.loadData();
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
        onAssociaUtente(item) {
            let me = this;
            me.loadDataUtenze();
            me.jsonDataAgendaBox.idBox = item.id;
            me.$refs.modalAssocia.show();
        },
        onSubmitUsers() {
            this.loadDataUtenze();
        },
        loadDataUtenze() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceUtenti;
            me.showModalLoading = true;
            me.filtroUsers.forPage = me.perPageUsers;
            me.filtroUsers.page = me.currentPageUsers;
            me.filtroUsers.username = me.mdlFiltroUsers.username;
            me.filtroUsers.profilo = me.mdlFiltroUsers.profilo;
            axios
                .get(link, { params: me.filtroUsers })
                .then((response) => {
                    me.isBusy = false;
                    me.showModalLoading = false;
                    me.itemsUtenti = response.data.data.list;
                })
                .catch((error) => {
                    this.$bvModal
                        .msgBoxOk(link + " \n" + error.message, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },

        onRowSelected(items) {
            this.selected = items;
        },
        onAssocia() {
            let me = this;
            // me.jsonDataAgendaBox.idBox = item.id;
            for (let i = 0; i < me.selected.length; i++) {
                let obj = { id: null, idBox: me.jsonDataAgendaBox.idBox, idUtente: me.selected[i].id };
                me.associaUtente(obj);
            }
        },
        associaUtente(obj) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAgendaBoxUtente + "/";
            axios
                .post(link, obj)
                .then((response) => {
                    me.$refs["modalAssocia"].hide();
                    response.data.data;
                    me.showModalLoading = false;
                    me.loadData();
                    //   console.log(me.jsonData);
                    this.$bvToast.toast(`Utente associato`, {
                        title: "Associazione Avvenuta con successp",
                        solid: true,
                        variant: "success",
                        autoHideDelay: 1000,
                        appendToast: true,
                    });
                })
                .catch((e) => {
                    console.log(e);
                    me.showModalLoading = false;
                    this.$bvModal
                        .msgBoxOk(link + " \n" + e.message, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
            //   console.log(obj);
        },
    },
};
</script>
